







































































import Vue from 'vue'
import Component from 'vue-class-component'
import { getModule } from 'vuex-module-decorators'
import AddressesPopup from '@/views/app/management/components/AddressesPopup.vue'
import { ResidentModule } from '@/store/modules/resident.module'
import Address from '@/views/app/management/components/Address.vue'
import { EPaymentReceiptType, EPaymentMethodType, EUserPermissions } from '@zunta/configurations'
import Vue2Filters from 'vue2-filters'
import Api from '@/api'
import { User } from '@/classes/User'
import Card from '@/components/Card.vue'
import ScheduleCallModal from '@/views/app/management/collections/components/GlobalAging/ScheduleCallModal.vue'

@Component({
  mixins: [Vue2Filters.mixin],
  name: 'OneTimeFailure',
  components: {
    ScheduleCallModal,
    Card,
    Address,
    AddressesPopup
  }
})
export default class OneTimeFailure extends Vue {
  mode: 'auto' = 'auto'
  EPaymentMethodType: any = EPaymentMethodType
  EPaymentReceiptType: any = EPaymentReceiptType
  EUserPermissions: any = EUserPermissions
  isRefund: boolean = false
  user: User = Api.getUser() as User
  residentModuleInstance: ResidentModule = getModule(ResidentModule, this.$store)
  showScheduleCallModal: boolean = false

  get residentId () {
    return this.$route.params.residentId
  }

  get fromCollections () {
    return !!this.$route.query.collectionReviewLink
  }

  get paymentId () {
    return this.$route.params.paymentId
  }

  get residentPayment () {
    return this.$store.state.resident.selectedPayment
  }

  get residentPaymentTransactions () {
    return this.$store.state.resident.selectedPaymentTransactions
  }

  get paymentContact () {
    return {
      fullName: this.residentPayment.receiptName,
      fullAddress: this.residentPayment.receiptAddress
    }
  }

  async mounted () {
    this.isRefund = this.$route.name === 'refund-success'
    this.$eventBus.$emit('loading:enable', { message: 'Loading...' })
    await this.residentModuleInstance.getResidentPayment(this.paymentId)
    setTimeout(() => this.$eventBus.$emit('loading:disable'), 300)
  }

  goBack () {
    if (this.user.isResident()) {
      this.$router.push({
        name: `resident-general`
      })
      return
    }

    if (this.$route.query.reviewLink) {
      const parts = (this.$route.query.reviewLink as string).split('.')
      this.$router.push({
        name: 'management-payments-review',
        params: {
          section: parts[0],
          scheduleItemId: parts[1]
        }
      })
      return
    }

    if (this.$route.query.collectionReviewLink) {
      const parts = (this.$route.query.collectionReviewLink as string).split('.')
      this.$router.push({
        name: 'management-collection-resident',
        params: {
          residentId: parts[2]
        },
        query: {
          type: parts[0]
        }
      })
      return
    }

    this.$locationManager.goBack({
      name: 'management-resident',
      params: { id: this.residentId }
    })
  }
}

